import { bigQuery } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { PACKAGE_NAME } from '../../constants';

type EventGroup = 'user_impressions' | 'user_action';

interface PageData {
    name?: string;
    component?: {
        name?: string;
    };
}

interface EventData {
    type: string;
    page?: PageData;
    [key: string]: any;
}

export const sendBqEvent = (group: EventGroup, { type, page = {}, ...rest }: EventData) => {
    const { userId, userGuid, pageCtxId, organizationId } = getContext();

    const pageData =
        page.name || page.component?.name
            ? {
                  ctx_id: pageCtxId,
                  ...page,
              }
            : null;

    const payload = {
        type,
        event_source: PACKAGE_NAME,
        organization: {
            id: organizationId,
        },
        entity: 'client',
        user: {
            id: userId,
            uid: userGuid,
        },
        group,
        sub_group: 'fiverr_pro',
        action: {
            type: 'click',
        },
        feature: {
            name: 'collections_events',
        },
        ...(pageData ? { page: pageData } : {}),
        ...rest,
    };

    bigQuery.send(payload);
};
